var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalPaidDataCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#FA5A7D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2 18.8044L17.0972 27.6579C16.7585 28.6243 15.8515 29.2705 14.834 29.2705H10.6C9.71634 29.2705 9 28.5491 9 27.6592C9 26.7693 9.71634 26.0479 10.6 26.0479H14.268L18.314 14.503C18.942 12.7112 21.4581 12.7113 22.086 14.503L29.8 36.514L32.9028 27.6604C33.2415 26.6941 34.1485 26.0479 35.166 26.0479H39.4C40.2837 26.0479 41 26.7693 41 27.6592C41 28.5491 40.2837 29.2705 39.4 29.2705H35.732L31.686 40.8154C31.058 42.6071 28.542 42.6071 27.914 40.8154L20.2 18.8044Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4071 10C33.7638 10 33.2422 10.5216 33.2422 11.1649V15.3184H29.1818C28.5291 15.3184 28 15.8475 28 16.5002C28 17.1529 28.5291 17.6821 29.1818 17.6821H33.2422V21.8351C33.2422 22.4784 33.7638 23 34.4071 23C35.0505 23 35.5721 22.4784 35.5721 21.8351V17.6821H39.6325C40.2852 17.6821 40.8143 17.1529 40.8143 16.5002C40.8143 15.8475 40.2852 15.3184 39.6325 15.3184H35.5721V11.1649C35.5721 10.5216 35.0505 10 34.4071 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalPaidDataCollection);
export default __webpack_public_path__ + "static/media/total-paid-data-collection.7e513e8686ba9ba05662c44928428dfe.svg";
export { ForwardRef as ReactComponent };